<nz-table
	#historiesTable
	[nzShowPagination]="true"
	[nzFrontPagination]="true"
	[nzPageSize]="10"
	[nzPageIndex]="pageIndex()"
	(nzPageIndexChange)="pageIndex.set($event)"
	[nzData]="assets()"
	[nzLoading]="loading()"
	[nzNoResult]="noData"
>
	<thead>
		<tr>
			<th>File Name</th>
			<th>URL</th>
			<th>Preview</th>
			<th>Download</th>
			<th>Copy</th>
			<th
				[nzSortFn]="sortByCreatedDesc"
				[nzSortOrder]="'ascend'"
				[nzSortDirections]="['descend', 'ascend', null]"
			>
				Created
			</th>
		</tr>
	</thead>
	<tbody>
		@for (asset of historiesTable.data; track asset) {
			<tr>
				<td class="truncate-text" [nz-tooltip]="asset.masked_filename">{{ asset.masked_filename }}</td>
				<td class="truncate-text" [nz-tooltip]="asset.url">{{ asset.url }}</td>
				<td>
					@switch (getPreviewType(asset.url)) {
						@case (MediaPreviewType.VIDEO) {
							<video controls [src]="asset.url" style="max-width: 100%; max-height: 200px"></video>
						}
						@case (MediaPreviewType.AUDIO) {
							<audio controls [src]="asset.url"></audio>
						}
						@case (MediaPreviewType.IMAGE) {
							<img [src]="asset.url" style="max-width: 100%; max-height: 200px" />
						}
						@case (MediaPreviewType.H5P) {
							<img [src]="'/assets/img/h5p.svg'" style="max-width: 100%; max-height: 200px" />
						}
						@default {
							<span class="unsupported">N/A</span>
						}
					}
				</td>
				<td>
					<div class="center">
						@if (getPreviewType(asset.url) === MediaPreviewType.H5P) {
							<span>N/A</span>
						} @else {
							<button nz-button (click)="downloadFile(asset)">
								@if (assetDownloading() !== asset) {
									<nz-icon nzType="download"></nz-icon>
								} @else {
									<nz-spin nzSimple nzSize="small"></nz-spin>
								}
							</button>
						}
					</div>
				</td>
				<td>
					<div class="center">
						<button nz-button (click)="copyToClipboard(asset.url)">
							<nz-icon nzType="copy"></nz-icon>
						</button>
					</div>
				</td>
				<td>{{ asset.created | date: 'short' }}</td>
			</tr>
		}
	</tbody>
	<ng-template #noData>
		<nz-typography>No media history entries available</nz-typography>
	</ng-template>
</nz-table>
